<template>
<div class="content_card_content">
<div class="grid">
<div class="col-12 md:col-6">



<FullCalendar  :options="options" ref="calendar"/>

	
</div>

<div class="col-12 md:col-6">
<div class="grid mt-6">

<div class="col-4">
<span class="p-float-label">
<MultiSelect v-model="selected_brands" :options="brands" optionLabel="name" optionValue="id"
      class="w-full p-inputtext-sm" @change="getProjects"/>
<label  class="text-primary">Marka Seçin</label>
</span>
</div>

<div class="col-4">
<span class="p-float-label">
<MultiSelect v-model="selected_projects" :options="projects" optionLabel="name" optionValue="id"
      class="w-full p-inputtext-sm" @change="getFlows"/>
<label  class="text-primary">Proje Seçin</label>
</span>
</div>

<div class="col-4">
<span class="p-float-label">
<MultiSelect v-model="selected_flows" :options="flows" optionLabel="name" optionValue="id"
      class="w-full p-inputtext-sm" @change="getEvents"/>
<label  class="text-primary">Aşama Seçin</label>
</span>
</div>

<div class="col-12">
<h4 class="text-purple-500">{{selected_date}} Günü Programı</h4>
<template v-if="loading_daily_events">
<FrameOverlay></FrameOverlay>
</template>
<template v-else>
<div class="grid mt-3">
<ScrollPanel style="width: 100%; height: 450px">
<div class="col-12" v-for="event in daily_events">
<router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'Supplier' , params: {id:event.supplier_id}}">{{event.supplier_name}}</router-link>
<br/>
<small class="text-purple-500"><b>Marka:</b>
{{event.brand_name}}
</small>
<br/>
<small class="text-purple-500"><b>Proje:</b>
{{event.project_name}}
</small>
<br/>
<small class="text-purple-500"><b>Aşama:</b>
{{event.flow_name}} 





</small>
<br/>
<small class="text-green-500"><b>Denetim Zamanı:</b>
{{event.schedule_date}} {{event.schedule_time}} 
</small>
<br/>
<small class="text-purple-500"><b>Durum:</b>
<Tag 
class="ml-2  mb-2 custom-chip" 
:value="getflowstatusname(event.flowsupplier_status)" 
:style="'background-color:'+getFlowstatuscolor(event.flowsupplier_status)"
/>
</small>
<br/>

<Button label="Görüntüle" class=" p-button-help   p-button-sm mt-3"  @click="gotoEvent(event)"></Button>
<hr>

</div>

</ScrollPanel>
</div>
</template>


</div>


</div>
</div>


</div>
</div>
</template>

<script>
import '@fullcalendar/core';
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import trLocale from '@fullcalendar/core/locales/tr';
import enLocale from '@fullcalendar/core/locales/en-gb';
import moment from "moment"
export default {

  name: 'AuditorAuditCalendar',

  data () {
    return {
    	loading:true,
      start:null,
      end:null,
    	loading_daily_events:true,
    	brands:[],
    	projects:[],
      dates_set:false,
    	flows:[],
    	selected_brands:[],
    	selected_projects:[],
    	selected_flows:[],
    	selected_date:null,
    	daily_events:[],
    	options: {
        plugins:[dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialDate : null,
        contentHeight:600,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        editable: false,
        selectable:true, 
        selectMirror: true, 
        dayMaxEvents: true,
        locale:trLocale,
        dateClick: this.handleDateClick,
        eventClick: this.hadleEventClick,
        datesSet: this.datesSet,
        eventsSet:this.eventsSet,
        events: [],
      },
    }
  },
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },
  watch:{
   
  },
  mounted()
  {
    this.selected_date = moment().format('YYYY-MM-DD');
    this.start = moment().startOf('month').format('YYYY-MM-DD');
    this.end   = moment().endOf('month').format('YYYY-MM-DD');
    this.getData()
    if(this.preflang==3)
    {
      this.options.locale = trLocale
    }
    if(this.preflang==15)
    {
      this.options.locale = enLocale
    }
  },
  methods:{
    getflowstatusname(status)
    {
      if(status=="created")
      {
        return this.$store.state.languages.lang_phrases.olusturuldu
      }
      if(status=="viewed")
      {
        return this.$store.state.languages.lang_phrases.goruntulendi
      }
      if(status=="started")
      {
        return this.$store.state.languages.lang_phrases.baslandi
      }
      if(status=="finished")
      {
        return this.$store.state.languages.lang_phrases.tamamlandi0
      }
      if(status=="under_review")
      {
        return this.$store.state.languages.lang_phrases.degerlendirmede
      }
      if(status=="canceled")
      {
        return this.$store.state.languages.lang_phrases.iptal_edildi
      }
      if(status=="correction_requested")
      {
        return this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede
      }
    },
    getFlowstatuscolor(status)
    {
      if(status=="created")
      {
        return "#352f8d"
      }
      if(status=="viewed")
      {
        return "#7e2f8d"
      }
      if(status=="started")
      {
        return "#dd4b39"
      }
      if(status=="finished")
      {
        return "#4dc247"
      }
      if(status=="under_review")
      {
        return "#ff6600"
      }
      if(status=="canceled")
      {
        return "#a82400"
      }
      if(status=="correction_requested")
      {
        return "#3b82f6"
      }
    },
    getFLowsupplierStatusName(status)
    {
      if(status=="created")
      {

      }
    },
    gotoEvent(event)
    {
      if(event.flow_type=="audit")
      {
        this.$router.push({ name: 'AuditorAuditSummary',params:{id:event.id} })
      }
      if(event.flow_type=="verification")
      {
        this.$router.push({ name: 'AuditorVerificationSummary',params:{id:event.id} })
      }
    },
    eventsSet(data)
    {
      this.dates_set = false
    },
    datesSet(data)
    {   
      this.start = moment(data.start).format('YYYY-MM-DD');
      this.end = moment(data.end).format('YYYY-MM-DD');
      if(!this.dates_set)
      {
        this.dates_set = true        
        setTimeout(()=>{
          this.getEvents()
        })        
      }      
    },
  	handleDateClick(data)
    {
    	console.log(data)  
    	this.selected_date = data.dateStr
    	this.getSelectedDateEvents()

    },
    hadleEventClick(data)
    {
      console.log(data)  
      this.selected_date  = moment(data.event._instance.range.start).format('YYYY-MM-DD');
      this.getSelectedDateEvents()
      
    },
  	createEventObj(item)
    {
           
      //let events = this.sanitizeArray(this.options.events)
      let duration = item.session_duration
      let end_moment = moment(item.schedule_date+" "+item.schedule_time,"Do-MM-YYYY HH:mm").add(duration,"minutes")
      let end_date = end_moment.format("Do-MM-YYYY")
      let end_hours = end_moment.format("HH:mm")     
      //this.options.events = events
      let event =  {
        id: item.id,
        title: item.supplier_name,
        start: item.schedule_date+" "+item.schedule_time,
        end:end_date+" "+end_hours,
      }
      //this.options.events.push(event)
      return event
    },
    async getData()
    {
    	
    	await this.getBrands()
    },
    async getBrands()
    {
    	this.selected_projects = []
    	this.selected_flows = []
    	let roles = this.$store.state.auth.user.userroles.map((item)=>{return item.name})
    	
    	this.brands =  await this.generalApiGet("brands") 
    	await this.getProjects()

    },
    async getProjects()
    {	    	
    	this.selected_projects = []
    	this.projects = []
    	let selected_brands = []

    	if(!this.selected_brands.length)
    	{
    		selected_brands = await this.brands.map((item)=>{return item.id})
    	}
    	else
    	{
    		selected_brands = this.selected_brands
    	}
    	for(let item of selected_brands)
    	{
    		let projects = await this.generalApiGetWithoutLoader("brand_projects/"+item) 
    		this.projects = this.projects.concat(projects)
    	}
    	await this.getFlows()
    },

    async getFlows()
    {	    	
    	let selected_projects = []

    	if(!this.selected_projects.length)
    	{
    		selected_projects = await this.brands.map((item)=>{return item.id})
    	}
    	else
    	{
    		selected_projects = this.selected_projects
    	}

    	this.flows = []
    	for(let item of selected_projects)
    	{
    		let flows = await this.generalApiGetWithoutLoader("project_flows/"+item)
    		flows = await flows.filter((item)=>{return item.type=="verification" || item.type=="audit"}) 
    		this.flows = this.flows.concat(flows)
    	}
    	await this.getEvents()
    	await this.getSelectedDateEvents()
    },

    async prepareQueryData()
    {
    	let brands = []
    	if(!this.selected_brands.length)
    	{
    		brands = await this.brands.map((item)=>{return item.id})
    	}
    	else
    	{
    		brands = await this.selected_brands
    	}

    	let projects = []
    	if(!this.selected_projects.length)
    	{
    		projects = await this.projects.map((item)=>{return item.id})
    	}
    	else
    	{
    		projects = await this.selected_projects
    	}

    	let flows = []
    	if(!this.selected_flows.length)
    	{
    		flows = await this.flows.map((item)=>{return item.id})
    	}
    	else
    	{
    		flows = await this.selected_flows
    	}

    	return {
    		brands:brands,
    		projects:projects,
    		flows:flows,
    	}
    },

    async getEvents()
    {
    	//this.loading = true
      
      console.log(this.start)
      console.log(this.end)
    	//this.options.events = []
    	let query_data = await this.prepareQueryData()
    	
    	let supplierverifications = await this.generalApiGetWithoutLoader("verification/get_verifications_calendar_data_for_auditor?start="+this.start+"&end="+this.end+"&brands="+JSON.stringify(query_data.brands)+"&projects="+JSON.stringify(query_data.projects)+"&flows="+JSON.stringify(query_data.flows))
      let events = []
    	for(let item of supplierverifications)
    	{
    		let event = await this.createEventObj(item)
        await events.push(event)
    	}
      this.dates_set = true 
      this.options.events = events
      
      this.loading = false
    },
    async getSelectedDateEvents()
    {
    	this.loading_daily_events = true
    	this.daily_events = []
    	let query_data = await this.prepareQueryData()
    	let daily_events = await this.generalApiGetWithoutLoader("verification/get_verifications_calendar_day_data_for_auditor?start="+this.start+"&end="+this.end+"&brands="+JSON.stringify(query_data.brands)+"&projects="+JSON.stringify(query_data.projects)+"&flows="+JSON.stringify(query_data.flows)+"&selected_date="+this.selected_date)
    	this.daily_events = daily_events
      
    	this.loading_daily_events = false
    },
  }
}
</script>

<style lang="css" scoped>
</style>